exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.label[data-v-aa5c97d0]{font-weight:bold;color:#606266\n}\n.text[data-v-aa5c97d0]{color:#696580\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/central/cadastros/para/retificacao/components/resumos/AppCollapse.vue"],"names":[],"mappings":";AA8EA,wBACE,iBACA,aAAc;CACf;AAAA,uBAGC,aAAc;CACf","file":"AppCollapse.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.label {\n  font-weight: bold;\n  color: #606266;\n}\n\n.text {\n  color: #696580;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aa5c97d0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/central/cadastros/para/retificacao/components/resumos/AppCollapse.vue
// module id = KsBH
// module chunks = 11